import { authHeader, history } from "../_helpers";
import { handleResponse } from "../_helpers/response";
import config from "../config";
const baseUrl = config.apiGateway.baseUrl;
export const superAdminService = {
  getCctvDistricts,
  updateCctvDistrict,
  getCctnsMissingPoliceStations,
  updateCctnsDistrictSecondaryName,
  CctnsMissingList,
  CctnsMissingUpdate,
  CctnsCityList,
  CctnsCityMap,
};
function getCctvDistricts() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${baseUrl}/criminal/cctns-districts/`, requestOptions).then(
    handleResponse,
  );
}
function updateCctvDistrict(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/update-cctvdistrict/`, requestOptions).then(
    handleResponse,
  );
}

function getCctnsMissingPoliceStations() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(
    `${baseUrl}/criminal/cctns-missing-police-stations`,
    requestOptions,
  ).then(handleResponse);
}

function updateCctnsDistrictSecondaryName(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/update-cctns-district-secondary-name`,
    requestOptions,
  ).then(handleResponse);
}

function CctnsMissingList(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(`${baseUrl}/criminal/cctns-missing-list/`, requestOptions).then(
    handleResponse,
  );
}

function CctnsMissingUpdate(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/cctns-missing-update/`,
    requestOptions,
  ).then(handleResponse);
}

function CctnsCityList() {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  return fetch(`${baseUrl}/criminal/cctns-city-list/`, requestOptions).then(
    handleResponse,
  );
}
function CctnsCityMap(values) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeader(),
    },
    body: JSON.stringify(values),
  };
  return fetch(
    `${baseUrl}/criminal/cctns-city-map/`,
    requestOptions,
  ).then(handleResponse);
}
